<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'consultationDetail',
})
</script>
<template>
  <div class="main detail-page">
    <a-card title="店铺信息" class="mb20">
      <a-spin :spinning="state.loading">
        <a-row :gutter="[16, 24]">
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺类型：</span>
              <span class="detail-value">{{ state.info.storeInfo?.storeTypeStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">场所业态类型：</span>
              <span class="detail-value">{{ state.info.storeInfo?.venueTypeStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">所属行业：</span>
              <span class="detail-value">{{ state.info.storeInfo?.industryStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺名称：</span>
              <span class="detail-value">{{ state.info.storeInfo?.storeName || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺地址：</span>
              <span class="detail-value">{{ [state.info.storeInfo?.areaStr,
              state.info.storeInfo?.detailAddress].filter(Boolean).join('') || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">店铺面积：</span>
              <span class="detail-value">{{ state.info.storeInfo?.buildingArea ? `${state.info.storeInfo.buildingArea}㎡`
                : '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">联系人：</span>
              <span class="detail-value">{{ state.info.storeInfo?.contactPerson || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="detail-item">
              <span class="detail-label">联系电话：</span>
              <span class="detail-value">{{ state.info.storeInfo?.contactPhone || '-' }}</span>
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </a-card>

    <a-card title="咨询详情">
      <a-spin :spinning="state.loading">
        <a-row :gutter="[16, 24]">
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">咨询单号：</span>
              <span class="detail-value">{{ state.info.consultationNo || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">咨询类型：</span>
              <span class="detail-value">{{ state.info.categoryStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">状态：</span>
              <span class="detail-value">{{ state.info.statusStr || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" class="empty-col"></a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">用户昵称：</span>
              <span class="detail-value">{{ state.info.userNickname || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">手机号：</span>
              <span class="detail-value">{{ state.info.phone || '-' }}</span>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6">
            <div class="detail-item">
              <span class="detail-label">提交时间：</span>
              <span class="detail-value">{{ state.info.submitTime || '-' }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="[16, 24]" class="mt20">
          <a-col :span="24">
            <div class="detail-item detail-item-full">
              <span class="detail-label">问题描述：</span>
              <div class="detail-desc-box detail-desc-box-wider">{{ state.info.problemDesc || '-' }}</div>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="[16, 24]" class="mt20">
          <a-col :span="24">
            <div class="detail-item detail-item-full">
              <span class="detail-label">上传图片：</span>
              <template v-if="state.info.imageUrls && state.info.imageUrls.length">
                <a-upload :file-list="imageFileList" list-type="picture-card" disabled>
                  <template #itemRender="{ file }">
                    <div class="ant-upload-list-item-container">
                      <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-image">
                        <div class="ant-upload-list-item-thumbnail">
                          <img :src="file.url || file.thumbUrl" :alt="file.name" />
                        </div>
                        <span class="ant-upload-list-item-actions">
                          <a class="ant-upload-list-item-action" @click.stop="handlePreview(file)" title="查看">
                            <EyeOutlined />
                          </a>
                          <a class="ant-upload-list-item-action" :href="file.url" :download="file.name" title="下载">
                            <DownloadOutlined />
                          </a>
                        </span>
                      </div>
                    </div>
                  </template>
                </a-upload>
                <a-image-preview-group
                  ref="previewGroupRef"
                  :preview="{ visible: previewVisible, current: previewCurrent, wrapClassName: 'consultation-detail-preview', onVisibleChange: (v: boolean) => previewVisible = v, onChange: (c: number) => previewCurrent = c }"
                >
                  <a-image
                    v-for="(url, index) in state.info.imageUrls"
                    :key="index"
                    :src="url"
                    :alt="`图片${index + 1}`"
                    :style="{ display: 'none' }"
                  />
                </a-image-preview-group>
              </template>
              <span v-else class="detail-value">无</span>
            </div>
          </a-col>
        </a-row>
        <div class="detail-footer">
          <a-button class="detail-close-btn" @click="goBack">关闭</a-button>
          <a-button v-if="isUnprocessed" class="detail-confirm-btn" type="primary" @click="onConfirm"
            v-auth="'consultation.dispose'">确认处理</a-button>
        </div>
      </a-spin>
    </a-card>
  </div>
</template>

<script setup lang="ts" name="consultationDetail">
import { reactive, ref, computed, onMounted, h } from 'vue'
import { EyeOutlined, DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { useConsultation } from '@/store/consultation/consultation'

const router = useRouter()
const route = useRoute()
const consultationStore = useConsultation()

const state = reactive({
  loading: false,
  info: {} as any
})

const previewVisible = ref(false)
const previewCurrent = ref(0)

const isUnprocessed = computed(() => state.info.status === 0)

const imageFileList = computed(() => {
  if (!state.info.imageUrls) return []
  return state.info.imageUrls.map((url: string, index: number) => {
    const name = url.split('/').pop() || `图片${index + 1}`
    return {
      uid: `-${index}`,
      name,
      status: 'done',
      url,
      thumbUrl: url
    }
  })
})

const handlePreview = (file: any) => {
  const index = imageFileList.value.findIndex((item: any) => item.url === file.url)
  previewCurrent.value = index >= 0 ? index : 0
  previewVisible.value = true
  return false
}

const onConfirm = () => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '"确认处理"后用户将收到处理完成的通知，是否确认处理？',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return consultationStore.confirmConsultation(state.info.id).then(() => {
        message.success('处理成功')
        goBack()
      })
    }
  })
}

const goBack = () => {
  router.push({ path: '/consultation' })
}

onMounted(async () => {
  const id = route.params.id as string
  if (!id) {
    goBack()
    return
  }
  state.loading = true
  try {
    const data: any = await consultationStore.getConsultationInfo(id)
    state.info = data || {}
  } catch {
    // baseService 已统一提示错误信息
  } finally {
    state.loading = false
  }
})
</script>

<style scoped lang="less">
.detail-page {
  .mb20 {
    margin-bottom: 20px;
  }

  .mt20 {
    margin-top: 20px;
  }

  :deep(.ant-card-head) {
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }

  :deep(.ant-card-body) {
    padding: 28px;
  }

  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      color: #666;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .detail-value {
      color: #333;
      word-break: break-all;
    }
  }

  .empty-col {
    min-height: 1px;
  }

  .detail-item-full {
    width: 100%;

    .detail-desc-box-wider {
      flex: 1;
      max-width: 75%;
    }
  }

  .detail-desc-box {
    min-height: 120px;
    padding: 12px 16px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background: #fff;
    color: #333;
    font-size: 14px;
    line-height: 1.6;
    word-break: break-all;
  }

  :deep(.ant-upload-list-item) {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    border: 1px dashed #d9d9d9;

    &.ant-upload-list-item-done {
      position: relative;

      &::before {
        position: absolute;
        inset: 0;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }

    .ant-upload-list-item-thumbnail {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .ant-upload-list-item-actions {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.45);
      opacity: 1;

      .ant-upload-list-item-action {
        color: #fff;
        background: transparent;
      }
    }
  }

  :global(.consultation-detail-preview) {
    .ant-image-preview-img {
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
    }
  }

  .detail-footer {
    display: flex;
    justify-content: center;
    padding: 40px 0 20px;

    .detail-close-btn {
      width: 120px;
      height: 40px;
      border: 1px solid #0C418F;
      border-radius: 20px !important;
      color: #0C418F;
      font-size: 16px;

      &:hover {
        color: #0D479C;
        border-color: #0D479C;
      }
    }

    .detail-confirm-btn {
      width: 120px;
      height: 40px;
      margin-left: 10px;
      background: #0D479C;
      border-color: #0D479C;
      border-radius: 20px !important;
      color: #fff;
      font-size: 16px;

      &:hover {
        background: #0C418F;
        border-color: #0C418F;
        color: #fff;
      }
    }
  }
}
</style>
